import { Button } from "@/components/ui/button";
import { ArrowRight, Check } from "lucide-react";
import { FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export function HeroPraVoceSection() {
  return (
    <section className="py-8 md:py-16 min-h-screen bg-n-bg-1">
      <div className="container">
        <div className="grid md:grid-cols-2 items-center gap-6">
          <div className="text-left">
            <p className="text-lg text-n-green font-semibold lg:mb-8 mb-4">
              &gt; Pra você
            </p>
            <h1
              className="text-5xl md:text-[56px] text-n-dark mb-4"
              style={{ fontFamily: "'Anton', sans-serif", lineHeight: "1.2em" }}
            >
              Segurança, agilidade e praticidade em cada transporte para você!
            </h1>
            <div className="hidden md:flex md:gap-6 gap-1 mb-6">
              <div className="flex gap-1 items-center border rounded-full border-n-neutral-lighter py-1 px-3 h-[34px]">
                <img src="/icons/reclameaqui.png" alt="Reclame aqui" />
                <p className="text-n-text-neutral font-medium text-xs">
                  Somos nota máxima no Reclame Aqui!
                </p>
              </div>
              <div className="flex gap-1 items-center border rounded-full border-n-neutral-lighter py-1 px-3 h-[34px]">
                <img src="/icons/icoGG.png" alt="google" />
                <p className="text-n-text-neutral font-medium text-xs flex items-center gap-1.5">
                  <FaStar className="text-n-text-neutral w-3 h-3" /> 5 estrelas
                  no Google!
                </p>
              </div>
            </div>
            <p className="text-lg text-n-text-neutral mb-6 max-w-xl">
              A <span className="font-bold">Nacional Go</span> oferece soluções
              pensadas para atender às principais necessidades de pessoas
              físicas em diferentes momentos da vida. Seja para mudanças,
              negócios particulares ou situações especiais, garantimos
              segurança, agilidade e praticidade em cada transporte.
            </p>

            <div className="flex gap-3 items-center mb-8">
              <div className="flex items-center gap-2 border border-n-neutral-lighter rounded-full h-10">
                <div className="bg-n-beige px-3 rounded-r-none rounded-l-full h-full flex items-center">
                  <Check className="w-5 h-5 text-n-green" />
                </div>
                <span className="text-sm text-n-text-neutral font-semibold pl-2 pr-4">
                  Cotação em segundos, sem burocracia
                </span>
              </div>
            </div>

            <Link to="/fazer-cotacao">
              <Button>
                Agendar meu transporte <ArrowRight className="ml-2" />
              </Button>
            </Link>
          </div>

          <div className="flex items-center justify-center">
            <ImageSvg
              src="mudanca.svg"
              alt="Ilustração de mudança com família"
              className="w-full lg:h-[500px] "
            />
          </div>
        </div>
      </div>
    </section>
  );
}
